import React, { Component } from 'react';
import { Button, Popup, Table } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import axios from 'axios';

class FaqTable extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            data: [{}],
            filterData: [],
            roleOptions: [],
            showFiltersOnButton: false,

        };
        this.deleteFaq = this.deleteFaq.bind(this);
    }


    deleteFaq(faqId) {
        axios.delete(`/faq/delete/${faqId}`)
            .then((res) => {
                this.setState({ loader: false, confirmation: false });
                toast('Uspješno ste izbrisali pitanje!');
                this.props.fetchData();
            }).catch(err => {
                toast('Došlo je do greške!');
            });
    }


    render() {
        return (
            <div>

                { this.props.data.length ?
                    <Table celled selectable compact >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan={1}>
                                    Pitanje
                                </Table.HeaderCell>
                                <Table.HeaderCell colSpan={5}>
                                    Odgovor
                                </Table.HeaderCell>
                                    {localStorage.getItem('activeRole').substr(0, 10) !== 'Studentska' && <Table.HeaderCell/>}
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            {this.props.data.map((el, index) =>
                                (<Table.Row >
                                    <Table.Cell verticalAlign="middle" colSpan={1} >
                                        {el.question}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" colSpan={5}>
                                        {el.answer}
                                    </Table.Cell>

                                    {localStorage.getItem('activeRole').substr(0, 10) !== 'Studentska' &&
                                    <Table.Cell verticalAlign="middle" className="text-center" >
                                        {this.state.confirmation === index ?
                                            <div>
                                                <h4>Jeste li sigurni?</h4>
                                                <Button.Group>
                                                    <Button
                                                        basic="true"
                                                        color="blue"
                                                        onClick={() => this.deleteFaq(el.id)}
                                                    > DA</Button>
                                                    <Button
                                                        basic="true"
                                                        color="red"
                                                        onClick={() => { this.setState({ confirmation: false }); }}
                                                    >  NE

                                                    </Button>
                                                </Button.Group>
                                            </div>

                                            : <div>
                                                <Popup
                                                    content="Izmjena"
                                                    position="top center"
                                                    trigger={

                                                        <Button
                                                            disabled={localStorage.getItem('activeRole') === 'Support'}
                                                            basic="true"
                                                            circular
                                                            icon="pencil"
                                                            size="tiny"
                                                            color="green"
                                                            onClick={() => {
                                                                this.props.showEditForm();
                                                                localStorage.setItem('faqItem', JSON.stringify(el));
                                                            }}
                                                        />}
                                                />

                                                <Popup
                                                    content="Brisanje"
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            disabled={this.state.locked || localStorage.getItem('activeRole') === 'Support'}
                                                            basic="true"
                                                            circular
                                                            icon="trash alternate"
                                                            size="tiny"
                                                            color="red"
                                                            onClick={() => this.setState({ confirmation: index })}
                                                        />}
                                                />


                                            </div>}

                                    </Table.Cell>}


                                </Table.Row>))

                            }


                        </Table.Body>
                    </Table> : 'Trenutno nema pitanja i odgovora.'}


            </div>
        );
    }
}

export default FaqTable;



// WEBPACK FOOTER //
// ./src/views/Admin/FAQ/FAQTable.js